import React, { useEffect, useCallback, useMemo } from 'react'

import { v4 as uniqid } from 'uuid'

import bemit from '@function/bemit'

export default function ModalContent (props)
{
	const id = useMemo(() => 'app-modal-dialog-' + uniqid());

	useEffect(function ()
	{
		if (props.open === false)
		{
			closeModal();
		}
		else
		{
			openModal();
		}
	},
	[props.open]);

	const openModal = useCallback(function ()
	{
		const modal = document.getElementById(id);

		if (!modal) return;

		temperDocumentScroll('remove');

		modal.focus();

		modal.classList.remove('c-modal-cover--fade');
		modal.lastChild.classList.remove('c-modal--fade');
	},
	[id]);

	const closeModal = useCallback(function (e)
	{
		const modal = document.getElementById(id);

		if (!modal) return;

		if (props['prevent-close']) return;

		const other_modal = document
		.querySelector('[id="' + id + '"] ~ .js-app-modal-cover');

		if (other_modal) return;

		modal.classList.add('c-modal-cover--fade');
		modal.lastChild.classList.add('c-modal--fade');

		if (props.open === true) props.onClose(e);
	},
	[id]);

	const stopPropagation = useCallback(e => e.stopPropagation(), []);

	const modal_controls = props.footer ? props.footer :
	(
		<button type="button" aria-label="Fermer"
			className={ props['close-classes'] || bemit('c-btn', ['rec', 'grey']) }
			onClick={ closeModal }>
			{ props['close-label'] || 'Fermer' }
		</button>
	);

	return (
		<aside id={ id }
			className={ 'js-app-modal-cover ' + bemit('c-modal-cover', props.bemit) }
			role="dialog" aria-modal="true" tabIndex="-1"
			aria-labelledby={ props['aria-label'] || props.title }
			onKeyDown={ handleKeyDown }
			onMouseDown={ closeModal }
			onTransitionEnd={ handleAnimationEnd }
			onAnimationEnd={ handleAnimationEnd }>

			<div className={ bemit('c-modal', props.bemit) }
				onMouseDown={ stopPropagation }
				onTransitionEnd={ stopPropagation }
				onAnimationEnd={ stopPropagation }>

				<div className="c-modal__header" id="modal-title">
					{
						props.title ?
						(
							<div className="c-modal__title">
								{ props.title }
							</div>
						)
						: undefined
					}
				</div>

				<div className="c-modal__body">
					{ props.children }
				</div>

				<div className="c-modal__controls-wrapper">
					<div className="c-modal__controls">
						{ modal_controls }
					</div>
				</div>

				<button type="button" className="c-modal__close"
					onClick={ closeModal }
					aria-labelledby={ 'modal-close' + id }>

					<span className="u-hide-visually" id={ 'modal-close' + id }>
						Fermer
					</span>

					<svg className="c-modal__close-icon" viewBox="0 0 40 40">
						<path d="M 10,10 L 30,30 M 30,10 L 10,30"></path>
					</svg>

				</button>

			</div>

		</aside>
	);

	function handleAnimationEnd (e)
	{
		props.onAnimationEnd(e);

		if (props.open !== true)
		{
			temperDocumentScroll('restore');
		}
	}

	function handleKeyDown (e)
	{
		if (e.keyCode !== 27) return;

		closeModal(e);
	}

	function temperDocumentScroll (what)
	{
		const native_scroller = document.scrollingElement || document.body;

		const scroll_width = window.innerWidth - native_scroller.clientWidth;

		let scroll_area = props['scroll-area']
		? document.querySelector(props['scroll-area'])
		: native_scroller;

		if (!scroll_area)
		{
			console.error('invalid modal scroll-area', props['scroll-area']);
		}

		if (scroll_area !== native_scroller)
		{
			scroll_area.style.paddingRight = what === 'remove'
			? scroll_width + 'px'
			: '';
		}

		if (what === 'remove')
		{
			document.querySelector('html').classList.remove('u-lock-scroll-' + id);
		}
		else
		{
			document.querySelector('html').classList.add('u-lock-scroll-' + id);
		}
	}
}